/* eslint-disable react/jsx-props-no-spreading */
import { useMemo } from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  IconButton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { formatUTCStringToTimezoneString } from '@utils/formatDate';
import { useTable } from 'react-table';
import { DeleteIcon } from '@chakra-ui/icons';
import Quill from './Quill';

const ScheduledEmails = ({ deleteScheduledEmail, scheduledEmails, handleClose }) => {
  const data = useMemo(() => scheduledEmails, [scheduledEmails]);

  if (!data) return null;

  const columns = useMemo(
    () => [
      {
        Header: 'Scheduled For',
        accessor: 'scheduledDeliveryAt',
        Cell: ({ row }) => {
          const { scheduledDeliveryAt } = row.original;
          return <Text>{formatUTCStringToTimezoneString({ dateString: scheduledDeliveryAt }) || null}</Text>;
        },
      },
      {
        Header: 'Email Body',
        accessor: 'htmlBody',
        Cell: ({ row }) => {
          const { htmlBody, subject } = row.original;
          return (
            <Accordion allowToggle width="450px" p={0}>
              <AccordionItem border="none">
                <AccordionButton>
                  <Box as="span" flex="1" textAlign="center">
                    {subject}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Box width="450px">
                    <Quill readOnly theme={null} setHtml={() => {}} templateValue={htmlBody} />
                  </Box>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          );
        },
      },
      {
        Header: 'Cancel',
        accessor: 'cancel',
        Cell: ({ row }) => {
          const { id } = row.original;
          return (
            <IconButton
              _hover={{ color: 'black.600' }}
              icon={<DeleteIcon color="black" _hover={{ color: 'primary.600' }} />}
              aria-label="delete email"
              onClick={() => {
                deleteScheduledEmail({ variables: { notificationId: id } });
                handleClose();
              }}
              variant="outline"
              size="lg"
            />
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scheduledEmails]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });

  return (
    <Box>
      <Box overflowX="scroll" overflowY="auto">
        <Table {...getTableProps()} variant="striped" colorScheme="primary" size="md">
          <Thead>
            {headerGroups.map((headerGroup) => (
              <Tr key={headerGroup} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th key={column} whiteSpace="nowrap" textAlign="center" {...column.getHeaderProps()}>
                    {column.render('Header')}
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <Tr key={row} {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td padding="1rem" key={cell} {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default ScheduledEmails;
